import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SendMessage as SendMessageMutation,
    SendMessageVariables as SendMessageMutationVariables,
    MessageSendInput,
} from 'nutshell-graphql-types';

import SEND_MESSAGE from '../mutations/send-message.graphql';

export const useSendMessage = (): {
    sendMessage: (input: MessageSendInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [messageSend, {loading, error}] = useMutation<
        SendMessageMutation,
        SendMessageMutationVariables
    >(SEND_MESSAGE);

    return {
        sendMessage: (input: MessageSendInput) => {
            return messageSend({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
